export enum CancelDialogAction {
  CANCEL = 'cancel',
  EXIT = 'exit',
  DONT_SHOW_AGAIN = 'dontShowAgain'
}
